var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "input-group col-xs-12" }, [
          _c("span", { staticClass: "input-group-addon" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.showLabels,
                  expression: "showLabels"
                }
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.showLabels)
                  ? _vm._i(_vm.showLabels, null) > -1
                  : _vm.showLabels
              },
              on: {
                change: function($event) {
                  var $$a = _vm.showLabels,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.showLabels = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.showLabels = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.showLabels = $$c
                  }
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "form-control" }, [_vm._v("Show Labels")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-group col-xs-12" }, [
          _c("span", { staticClass: "input-group-addon" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.showPoints,
                  expression: "showPoints"
                }
              ],
              attrs: { type: "checkbox" },
              domProps: {
                checked: Array.isArray(_vm.showPoints)
                  ? _vm._i(_vm.showPoints, null) > -1
                  : _vm.showPoints
              },
              on: {
                change: function($event) {
                  var $$a = _vm.showPoints,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.showPoints = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.showPoints = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.showPoints = $$c
                  }
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "form-control" }, [_vm._v("Show Points")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "input-group col-xs-12" }, [
          _c("span", { staticClass: "input-group-addon" }, [_vm._v("Scale")]),
          _vm._v(" "),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.number",
                value: _vm.resultScale,
                expression: "resultScale",
                modifiers: { number: true }
              }
            ],
            staticClass: "form-control",
            attrs: {
              type: "range",
              "aria-label": "Gary's Scale",
              min: "0.01",
              max: "20.00",
              step: "0.1"
            },
            domProps: { value: _vm.resultScale },
            on: {
              __r: function($event) {
                _vm.resultScale = _vm._n($event.target.value)
              },
              blur: function($event) {
                return _vm.$forceUpdate()
              }
            }
          })
        ]),
        _vm._v(" "),
        _vm.runningLocally
          ? _c("button", { on: { click: _vm.toggleRun } }, [
              _vm._v("Toggle Run")
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "easel-canvas",
        {
          ref: "canvas",
          staticStyle: { "background-color": "grey" },
          attrs: {
            width: _vm.width,
            height: _vm.height,
            "viewport-width": "400",
            "viewport-height": "300",
            "anti-alias": false
          },
          on: { click: _vm.toggleRun }
        },
        [
          _c("easel-bitmap", {
            attrs: {
              image: "images/gulfstream_park.jpg",
              x: "200",
              y: "150",
              scale: 300 / 850,
              align: ["center", "center"]
            }
          }),
          _vm._v(" "),
          _vm._l(_vm.points, function(point, i) {
            return _vm.showPoints
              ? _c("easel-shape", {
                  key: i,
                  attrs: {
                    form: "circle",
                    dimensions: "3",
                    stroke: "black",
                    fill: point === _vm.gary.target ? "red" : "white",
                    x: point[0],
                    y: point[1],
                    align: ["center", "center"]
                  }
                })
              : _vm._e()
          }),
          _vm._v(" "),
          _c(
            "easel-sprite-sheet",
            {
              attrs: {
                images: ["images/lastguardian-all.png"],
                frames: { width: 32, height: 32 },
                animations: {
                  stand: _vm.garyStart + 5,
                  runRight: [_vm.garyStart + 6, _vm.garyStart + 7],
                  runUp: [_vm.garyStart + 0, _vm.garyStart + 1],
                  runDown: [_vm.garyStart + 2, _vm.garyStart + 3]
                },
                framerate: 30
              }
            },
            [
              _c(
                "easel-container",
                {
                  attrs: {
                    x: _vm.gary.x,
                    y: _vm.gary.y,
                    scale: _vm.resultScale
                  }
                },
                [
                  _c("easel-shape", {
                    attrs: {
                      fill: "black",
                      form: "ellipse",
                      dimensions: [16, 4],
                      alpha: ".3",
                      align: "center-center"
                    }
                  }),
                  _vm._v(" "),
                  _c("easel-sprite", {
                    attrs: {
                      animation: _vm.gary.animation,
                      flip: _vm.gary.flip,
                      align: "bottom-center"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.showLabels
                ? _c("easel-text", {
                    attrs: {
                      text: "Gary",
                      color: "yellow",
                      font: "20px Helvetica",
                      align: "alphabetic-center",
                      filters: [
                        ["PixelStrokeFilter", [0, 0, 0], 2 * _vm.resultScale]
                      ],
                      x: _vm.gary.x,
                      y: _vm.gary.y - 40 * _vm.resultScale,
                      scale: _vm.resultScale
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }